// @ts-check

/** @file Installs the ES2024 Promise.withResolvers primitive required by Velocious 1.0.672. */

/**
 * Installs `Promise.withResolvers` for Hermes versions that predate ES2024.
 * Native Velocious websocket shutdown and bounded database admission use this
 * primitive; the standards-shaped fallback preserves their normal lifecycle.
 * @returns {void} Nothing.
 */
export function installPromiseWithResolvers() {
  if (typeof Promise.withResolvers === "function") return

  Object.defineProperty(Promise, "withResolvers", {
    configurable: true,

    /**
     * Creates a promise together with its settlement callbacks.
     * @returns {{promise: Promise<unknown>, reject: (reason?: unknown) => void, resolve: (value: unknown) => void}} Promise capability.
     */
    value: function withResolvers() {
      /** @type {(reason?: unknown) => void} */
      let reject
      /** @type {(value: unknown) => void} */
      let resolve
      const promise = new Promise((promiseResolve, promiseReject) => {
        resolve = promiseResolve
        reject = promiseReject
      })

      return {promise, reject, resolve}
    },
    writable: true
  })
}

installPromiseWithResolvers()
